module.exports = __webpack_public_path__ + "img/img-10.160361da.png";